// extracted by mini-css-extract-plugin
export var container = "_5e-0";
export var icon = "_5e-1";
export var text = "_5e-2";